export default {
  data() {
    return {
      mobileValid: false
    };
  },
  methods: {
    mobileValidator(mobile) {
      if (!mobile) {
        this.$toast('请输入正确的手机号');
        this.mobileValid = false;
      } else if (!this.$util.isMobileValid(mobile)) {
        this.mobileValid = false;
        this.$toast('手机号格式错误');
      } else {
        this.mobileValid = true;
      }
      return this.mobileValid;
    }
  }
};
